import {Component, Input} from '@angular/core';
import {CrudSavePopupComponent} from '../../_directives';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AddressService, AlertService, LoaderService, PhoneService, UserService} from '../../_services';
import {FormBuilder, Validators} from '@angular/forms';
import {
  Address,
  Campaign, CustomDomain, getPhoneNumberTypesForCountry, Pager,
  PhoneNumberTypeEnum,
  PhoneProviderType, PhoneResourceType,
  PhoneSearchResult,
  PhoneUseTypeEnum,
  Region,
  User,
  PhoneNumberCost,
} from '../../_models';
import {config} from '../../../config/config';

@Component({
  templateUrl: './phone-setup-popup.component.html',
  selector: 'app-phone-setup',
  styleUrls: ['../campaign-section.scss', './campaign-phone-setup.component.scss']
})
export class PhoneSetupPopupComponent extends CrudSavePopupComponent {
  private providerType: PhoneProviderType = PhoneProviderType.Telnyx;
  public countries: Region[] = [{id: 'us', name: 'United States of America'}];
  public country: string = 'us';
  public phoneNumberType: PhoneNumberTypeEnum = PhoneNumberTypeEnum.Local;
  public areaCode: number = null;
  public phoneNumberTypes = [];
  public showSearchControls: boolean = true;
  public phoneNumberResults: { string?: PhoneSearchResult[] } = {};
  public selectedPhoneNumber = null;
  public selectedPhoneNumberCost: PhoneNumberCost = null;
  @Input('campaign') campaign: Campaign = null;
  public domains: CustomDomain[] = [];
  public useTypes = [
    {value: PhoneUseTypeEnum.VoiceAndSMS, label: 'Voice & SMS'},
    {value: PhoneUseTypeEnum.VoiceOnly, label: 'Voice Only'},
    {value: PhoneUseTypeEnum.SMSOnly, label: 'SMS Only'}
  ];
  public addresses: Address[] = [];
  public showPhoneError: boolean = false;
  public user: User;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected phoneService: PhoneService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected loaderService: LoaderService,
    protected addressService: AddressService,
    protected userService: UserService
  ) {
    super(router, location, route, phoneService, alertService);
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      phone: [null, Validators.required],
      type: [null, Validators.required],
      campaign: [null],
      domain: [null],
      address: [null, Validators.required],
      use_type: [PhoneUseTypeEnum.VoiceAndSMS, Validators.required],
      resourcetype: [null],
    });
    super.ngOnInit();

    if (this.inputData && this.inputData.id) {
      this.showSearchControls = false;
      this.selectedPhoneNumber = this.inputData.phone;
      this.selectedPhoneNumberCost = null;

      if (this.inputData.address && this.inputData.address.id) {
        this.form.patchValue({address: this.inputData.address.id});
      }
    }

    this.selectTypesForCountry(this.country);

    if (this.campaign && this.campaign.id) {
      this.form.patchValue({campaign: this.campaign.id});
      this.domains = this.campaign.custom_domains;
    }

    this.addressService.list({page: 1, page_size: config.maxPageSize})
      .subscribe(
        (data: Pager) => {
          this.addresses = data.results;
        },
        error => {
          this.handleError(error);
        }
      );

    this.userService.getCurrent().subscribe((user: User) => {
      this.user = user;
    });
  }

  private selectTypesForCountry(country: string) {
    this.phoneNumberTypes = getPhoneNumberTypesForCountry(country);
  }

  getSearchResultsKey() {
    return `${this.country}:${this.phoneNumberType}:${this.areaCode || 'null'}`;
  }

  chooseFromResult() {
    const results = this.phoneNumberResults[this.getSearchResultsKey()] || [];
    const index = Math.floor(Math.random() * results.length);
    this.selectedPhoneNumber = results[index].value;
    this.selectedPhoneNumberCost = results[index].cost;
    results.splice(index, 1);
    this.phoneNumberResults[this.getSearchResultsKey()] = results;
  }

  search() {
    const results = this.phoneNumberResults[this.getSearchResultsKey()] || [];
    this.selectedPhoneNumber = null;
    this.selectedPhoneNumberCost = null;
    this.showPhoneError = false;
    if (results.length > 0) {
      this.chooseFromResult();
    } else {
      let searchQuery = {
        type: this.phoneNumberType,
        area_code: this.areaCode,
        pattern: null,
        country: this.country,
        provider_type: this.providerType,
      };
      this.loaderService.show();

      this.phoneService.search(searchQuery)
        .subscribe((results: PhoneSearchResult[]) => {
          if (results && results.length > 0) {
            this.phoneNumberResults[this.getSearchResultsKey()] = results;
            this.chooseFromResult();
          } else {
            this.showPhoneError = true;
          }
          this.loaderService.hide();
        }, error => {
          this.loaderService.hide();
          this.handleError(error);
        });
    }
  }

  populateForm() {
    this.form.patchValue({
      phone: this.selectedPhoneNumber,
      type: this.phoneNumberType,
      resourcetype: PhoneResourceType.Telnyx
    });
    this.showSearchControls = false;
  }

  get selectedAddress() {
    return this.form.value.address;
  }

  get showCost() {
    return this.selectedPhoneNumber && this.selectedPhoneNumberCost && this.user && this.user.is_staff;
  }
}
